/* eslint-disable import/no-cycle */
/* eslint-disable camelcase */
import {
	clear,

	clearCustomers,
	addCustomer,
	removeCustomer,

	clearOwners,
	addOwner,
	removeOwner,

	clearParentTypeKeys,
	addParentTypeKey,
	removeParentTypeKey,

	clearParentNames,
	addParentName,
	removeParentName,

	clearSurveyTypes,
	addSurveyType,
	removeSurveyType,
} from './actions';

const EMPTY_OBJECT = {};

// ************
// PARTS
// ************
const reducerParts = {
	[clear]: state => {
		return {
			...state,
			selectedCustomers: EMPTY_OBJECT,
			selectedOwners: EMPTY_OBJECT,
			selectedParentTypeKeys: EMPTY_OBJECT,
			selectedParentNames: EMPTY_OBJECT,
			selectedSurveyTypes: EMPTY_OBJECT,
		};
	},

	// ***********
	// CUSTOMERS
	// ***********

	[clearCustomers]: state => {
		return {
			...state,
			selectedCustomers: EMPTY_OBJECT,
		};
	},

	[addCustomer]: (state, { payload: { customer } = {}} = {}) => {
		const map = {...state.selectedCustomers };

		if (map[customer]) {
			return state;
		}

		map[customer] = true;
		return {
			...state,
			selectedCustomers: map,
		};
	},

	[removeCustomer]: (state, { payload: { customer } = {}} = {}) => {
		const map = {...state.selectedCustomers };

		if (!map[customer]) {
			return state;
		}

		delete map[customer];
		return {
			...state,
			selectedCustomers: map,
		};
	},

	// ***********
	// OWNERS
	// ***********

	[clearOwners]: state => {
		return {
			...state,
			selectedOwners: EMPTY_OBJECT,
		};
	},

	[addOwner]: (state, { payload: { owner } = {}} = {}) => {
		const map = {...state.selectedOwners };

		if (!owner?.compositeId || map[owner?.compositeId]) {
			return state;
		}

		map[owner.compositeId] = true;
		return {
			...state,
			selectedOwners: map,
		};
	},

	[removeOwner]: (state, { payload: { owner } = {}} = {}) => {
		const map = {...state.selectedOwners };

		if (!owner?.compositeId || !map[owner?.compositeId]) {
			return state;
		}

		delete map[owner.compositeId];
		return {
			...state,
			selectedOwners: map,
		};
	},


	// ***********
	// PARENT TYPE KEYS
	// ***********

	[clearParentTypeKeys]: state => {
		return {
			...state,
			selectedParentTypeKeys: EMPTY_OBJECT,
		};
	},

	[addParentTypeKey]: (state, { payload: { parentTypeKey } = {}} = {}) => {
		const map = {...state.selectedParentTypeKeys };

		if (map[parentTypeKey]) {
			return state;
		}

		map[parentTypeKey] = true;
		return {
			...state,
			selectedParentTypeKeys: map,
		};
	},

	[removeParentTypeKey]: (state, { payload: { parentTypeKey } = {}} = {}) => {
		const map = {...state.selectedParentTypeKeys };

		if (!map[parentTypeKey]) {
			return state;
		}

		delete map[parentTypeKey];
		return {
			...state,
			selectedParentTypeKeys: map,
		};
	},

	// ***********
	// PARENT NAMES
	// ***********

	[clearParentNames]: state => {
		return {
			...state,
			selectedParentNames: EMPTY_OBJECT,
		};
	},

	[addParentName]: (state, { payload: { name: parentName } = {}} = {}) => {
		const map = {...state.selectedParentNames };

		if (map[parentName]) {
			return state;
		}

		map[parentName] = true;
		return {
			...state,
			selectedParentNames: map,
		};
	},

	[removeParentName]: (state, { payload: { name: parentName } = {}} = {}) => {
		const map = {...state.selectedParentNames };

		if (!map[parentName]) {
			return state;
		}

		delete map[parentName];
		return {
			...state,
			selectedParentNames: map,
		};
	},

	// ***********
	// SURVEY TYPES
	// ***********

	[clearSurveyTypes]: state => {
		return {
			...state,
			selectedSurveyTypes: EMPTY_OBJECT,
		};
	},

	[addSurveyType]: (state, { payload: { surveyType } = {}} = {}) => {
		const map = {...state.selectedSurveyTypes };

		if (map[surveyType]) {
			return state;
		}

		map[surveyType] = true;
		return {
			...state,
			selectedSurveyTypes: map,
		};
	},

	[removeSurveyType]: (state, { payload: { surveyType } = {}} = {}) => {
		const map = {...state.selectedSurveyTypes };

		if (!map[surveyType]) {
			return state;
		}

		delete map[surveyType];
		return {
			...state,
			selectedSurveyTypes: map,
		};
	},
};

export default reducerParts;
